import { Component, Prop,  h, Method } from '@stencil/core';

@Component({
  tag: 'zpr-dropdown-menu'
})

export class ZprDropdownMenu {
  private _dropdown:HTMLZprDropdownElement;

  @Prop({reflect: true}) direction:string;
  @Prop({reflect: true}) size:string;

  @Method()
  async open(){
    this._dropdown.open();
  }

  @Method()
  async close(){
    this._dropdown.close();
  }


  render() {
    return (
      <zpr-dropdown direction={this.direction} size={this.size} ref={ el => this._dropdown = el }>
        <slot name="toggle"/>
        <slot name="body"/>
      </zpr-dropdown>
    )
  }
}